import { Controller } from "@hotwired/stimulus"

import { formatPrice } from "@/helpers/price_format"
import { pluralize } from "@/helpers/pluralize"

export default class extends Controller<HTMLElement> {
  static targets = [
    "guests",
    "paxRadio",
    "productList",
    "productRadio",
    "productType",
    "totalPrice"
  ]
  declare readonly guestsTarget: HTMLElement
  declare readonly paxRadioTargets: HTMLInputElement[]
  declare readonly productListTargets: HTMLElement[]
  declare readonly productRadioTargets: HTMLInputElement[]
  declare readonly productTypeTarget: HTMLElement
  declare readonly totalPriceTarget: HTMLElement

  connect(): void {
    this.updateTotalPrice()
  }

  selectOccupancy(): void {
    this.toggleProductList()
    const currentSelectedProduct = this.selectedProductRadio.value

    const productRadiosForSelectedPax = this.productRadioTargets.filter(
      this.matchesSelectedPax.bind(this)
    )
    const productToSelect =
      productRadiosForSelectedPax.find((radio) => radio.value === currentSelectedProduct) ||
      productRadiosForSelectedPax[0]

    productToSelect.checked = true

    this.guestsTarget.textContent = pluralize(parseInt(this.selectedPax), "guest")
    this.updateTotalPrice()
  }

  selectProduct(): void {
    this.updateTotalPrice()
    this.productTypeTarget.textContent = this.selectedProductRadio.dataset.label!
  }

  updateTotalPrice(): void {
    this.totalPriceTarget.textContent = formatPrice(
      parseFloat(this.selectedProductRadio.dataset.price!)
    )
  }

  private toggleProductList(): void {
    this.productListTargets.forEach((list) => {
      list.hidden = !this.matchesSelectedPax(list)
    })
  }

  private matchesSelectedPax(element: HTMLElement): boolean {
    return element.dataset.occupancy! === this.selectedPax
  }

  private get selectedPax(): string {
    return this.paxRadioTargets.find((radio) => radio.checked)!.value
  }

  private get selectedProductRadio(): HTMLInputElement {
    return this.productRadioTargets.find((product) => product.checked)!
  }
}
